import styled from 'styled-components';

import { crFont9 } from '../../../app/global-styles';

import { Icon } from '@controlrooms/components';

export const Container = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  padding: 8px 4px;
  background: ${({ theme }) => theme.viewControls.container.background};
  box-shadow: 0px 4px 16px 0px rgba(0, 0, 0, 0.15);
  min-width: 0; /* Allow flex shrinking */
  overflow: visible; /* Allow tooltips to be visible */
`;

export const Left = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  flex-shrink: 0; /* Don't let navigation buttons shrink */
`;

export const ViewModes = styled.div`
  display: flex;
  gap: 4px;
`;

export const ViewModeButton = styled.button<{ selected?: boolean }>`
  display: flex;
  align-items: center;
  padding: ${({ selected }) => (selected ? '2px 14px' : '4px 16px')};
  border-radius: 4px;
  cursor: pointer;
  background: ${({ selected, theme }) =>
    selected ? theme.viewControls.tabs.selectedBackground : theme.viewControls.tabs.background};
  border: ${({ selected, theme }) =>
    selected ? `2px solid ${theme.viewControls.tabs.selectedBorder}` : 'none'};
  box-shadow: ${({ selected }) =>
    selected
      ? '0px 4px 6px 0px rgba(255, 255, 255, 0.1), 0px -3px 4px 0px rgba(0, 0, 0, 0.1), inset 0px -2px 4px 0px rgba(255, 255, 255, 0.1), inset 0px 2px 3px 0.5px rgba(0, 0, 0, 0.1)'
      : '0px 4px 6px 0px rgba(0, 0, 0, 0.1), 0px -4px 4px 0px rgba(255, 255, 255, 0.1), inset 0px -2px 4px 0px rgba(0, 0, 0, 0.1), inset 0px 1px 1px 0px rgba(255, 255, 255, 0.1)'};

  svg {
    path {
      fill: ${({ selected, theme }) =>
        selected ? theme.viewControls.tabs.selectedIcon : theme.viewControls.tabs.icon};
      stroke: none;
    }
  }
`;

export const Center = styled.div`
  display: flex;
  align-items: center;
  // gap: 16px;
`;

export const UtilityGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  background: ${({ theme }) => theme.viewControls.container.background};
  border-radius: 100px;
  box-shadow: 0px 4px 6px 0px rgba(0, 0, 0, 0.1), 0px -4px 4px 0px rgba(255, 255, 255, 0.1),
    inset 0px -2px 4px 0px rgba(0, 0, 0, 0.1), inset 0px 1px 1px 0px rgba(255, 255, 255, 0.1);
  padding: 2px 8px;
  height: 26px;
`;

export const UtilityButton = styled.button`
  display: flex;
  align-items: center;
  gap: 2px;
  padding: 4px 8px 4px 4px;
  border-radius: 4px;
  background: transparent;
  border: none;
  font-family: 'Open Sans', sans-serif;
  font-weight: 700;
  font-size: 9px;
  text-transform: uppercase;
  color: ${({ theme }) => theme.viewControls.content.text};
  cursor: pointer;
  svg {
    path {
      fill: ${({ theme }) => theme.viewControls.content.text};
      stroke: none;
    }
  }
`;

export const DropdownIcon = styled(Icon)`
  margin-left: 4px;
`;

export const ScaleGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  background: ${({ theme }) => theme.viewControls.container.background};
  border-radius: 100px;
  box-shadow: 0px 4px 6px 0px rgba(0, 0, 0, 0.1), 0px -4px 4px 0px rgba(255, 255, 255, 0.1),
    inset 0px -2px 4px 0px rgba(0, 0, 0, 0.1), inset 0px 1px 1px 0px rgba(255, 255, 255, 0.1);
  padding: 2px;
`;

export const ScaleLabel = styled.span`
  font-family: 'Open Sans', sans-serif;
  font-weight: 700;
  font-size: 9px;
  text-transform: uppercase;
  color: ${({ theme }) => theme.viewControls.content.textSecondary};
  padding: 0 8px;

  @media (max-width: 1280px) {
    display: none;
  }
`;

export const ToggleGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  background: ${({ theme }) => theme.viewControls.toggle.background};
  border-radius: 10px;
  border: 1px solid ${({ theme }) => theme.viewControls.toggle.border};
  box-shadow: inset 1px 2px 4px 0px rgba(0, 0, 0, 0.1);
  padding: 3px;
  width: 123px;
`;

export const ToggleOption = styled.button<{ selected?: boolean }>`
  flex: 1;
  border-radius: 10px;
  background: ${({ selected }) => (selected ? '#f7f7f5' : 'transparent')};
  box-shadow: ${({ selected }) => (selected ? '0px 1px 2px 0px rgba(0, 0, 0, 0.2)' : 'none')};
  border: none;
  font-family: 'Open Sans', sans-serif;
  font-weight: 700;
  font-size: 9px;
  text-transform: uppercase;
  color: ${({ selected }) => (selected ? '#1e1e1e' : '#737373')};
  padding: 2px 8px;
`;

export const Right = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end; /* Right align contents */
  gap: 8px;
  min-width: 0; /* Allow flex shrinking */
  flex: 1; /* Take available space but allow shrinking */
`;

export const TimeLabel = styled.div`
  ${crFont9}
  text-transform: uppercase;
  color: ${({ theme }) => theme.viewControls.content.textSecondary};
  padding: 0 8px;
`;

export const TimeControls = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  background: ${({ theme }) => theme.viewControls.container.background};
  border-radius: 100px;
  box-shadow: 0px 4px 6px 0px rgba(0, 0, 0, 0.1), 0px -4px 4px 0px rgba(255, 255, 255, 0.1),
    inset 0px -2px 4px 0px rgba(0, 0, 0, 0.1), inset 0px 1px 1px 0px rgba(255, 255, 255, 0.1);
  padding: 2px 8px;
  height: 26px;
  min-width: 180px;
  width: fit-content; /* Content-based width */
  overflow: visible; /* Allow tooltips to be visible */
  position: relative; /* Create positioning context */
`;

export const TimeRange = styled.div`
  display: flex;
  align-items: center;
  border-radius: 3px;
  font-family: 'Open Sans', sans-serif;
  font-weight: 600;
  font-size: 11px;
  color: #1e1e1e;
  min-width: 15px; /* Allow shrinking for ellipsis */
  flex: 1; /* Take available space */
`;

export const IconicButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4px;
  border-radius: 4px;
  background: transparent;
  border: none;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    box-shadow: ${({ theme }) => theme.button.boxShadow};
  }

  svg {
    width: 16px;
    height: 16px;
    path {
      fill: ${({ theme }) => theme.assessVisualizer.button.color};
    }
  }
`;
